import { CLASSIFICATION_TYPE, PAGE_TYPE } from "../../../constants";
import { eventTrackPayloadCreator } from "../../../helpers/eventPayloadCreator";
import { EventData } from "../../../types";
import { TokenTransferEventPayload } from "./types";

const AnalyticsEventData: EventData = {
  pageDetail: "",
  pageType: PAGE_TYPE.tokenTransfer,
  eventName: "Token Transfer Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createTokenTransferClickedTrackEventPayload =
  eventTrackPayloadCreator<TokenTransferEventPayload>(AnalyticsEventData);
